export default __webpack_public_path__ + "img/657ff6b022b39bc2d7fbed8e20dcf3bb.png";